export default function createHistoryDb(userId) {
  if (!('indexedDB' in window)) {
    console.log('This browser doesn\'t support IndexedDB');
    return;
  }
  const request = indexedDB.open(`search_history_${userId}`, 1);

  request.onerror = (e) => {
    console.log('Error', e);
  };
  request.onsuccess = () => {
    console.log('Db is open now!');
  };
  request.onupgradeneeded = (e) => {
    const db = e.target.result;
    db.createObjectStore('customers', {
      keyPath: 'id',
      autoIncrement: true,
    });
    db.createObjectStore('queries', {
      keyPath: 'id',
      autoIncrement: true,
    });
    db.createObjectStore('events', {
      keyPath: 'id',
      autoIncrement: true,
    });
    db.createObjectStore('posts', {
      keyPath: 'id',
      autoIncrement: true,
    });
    db.createObjectStore('companies', {
      keyPath: 'id',
      autoIncrement: true,
    });
  };
}
